<div class="c-change-app-menu" id="divChangeAppMenu">
  <button
    mat-icon-button
    id="btnChangeApp"
    [matMenuTriggerFor]="change_app"
    *hasPermission="[PERMISSION.MODULE_APP_ICON]"
  >
    <mat-icon id="matApps">apps</mat-icon>
  </button>
  <mat-menu id="matMenuOption" #change_app="matMenu" class="c-change-app-option">
    <mat-grid-list id="matGridList" cols="3" gutterSize="4px" rowHeight="1:1.6">
      <!-- will change this code while will show organizations after login with global admin user-->
      <ng-container *ngIf="organizations">
        <div *ngFor="let organization of organizations">
          <mat-grid-tile [id]="'mat' + organization.name" matRipple>
            <a [href]="[organization.accessUrl]" [id]="'a' + organization.name" target="_blank">
              <div class="c-app-icon-box" [id]="'divIcon' + organization.name">
                <div class="c-app-icon" [id]="'divApp' + organization.name">
                  <img [src]="[organization.image]" [id]="'img' + organization.name" />
                </div>
                <div class="c-app-text" [id]="'divAppText' + organization.name">
                  {{organization.name}}
                </div>
              </div>
            </a>
          </mat-grid-tile>
        </div>
      </ng-container>
      <ng-container *ngIf="applications">
        <div *ngFor="let application of applications" [id]="'div' + application.shortName">
          <mat-grid-tile
            [id]="'mat' + application.shortName"
            matRipple
            *ngIf="application.shortName.toLowerCase() === currentApplicationName"
          >
            <a [id]="'a' + application.shortName">
              <div class="c-app-icon-box" [id]="'divIcon' + application.shortName">
                <div class="c-app-icon" [id]="'divApp' + application.shortName">
                  <img
                    [src]="application.shortName | moduleDisplayLogo | async"
                    [id]="'img' + application.shortName"
                  />
                </div>
                <div class="c-app-text" [id]="'divAppText' + application.shortName"><br /></div>
              </div>
            </a>
          </mat-grid-tile>
        </div>
        <!-- TODO: Remove static ui -->
        <div *ngFor="let application of applications">
          <mat-grid-tile
            [id]="'matGridTile' + application.shortName"
            matRipple
            *ngIf="application.shortName.toLowerCase() !== currentApplicationName"
          >
            <a
              [href]="[application.shortName.toLowerCase()+'/']"
              [id]="'aApp' + application.shortName"
              (click)="updateUserPermission(application.shortName)"
            >
              <div class="c-app-icon-box" [id]="'divIconBox' + application.shortName">
                <div class="c-app-icon" [id]="'divCAppIcon' + application.shortName">
                  <img
                    [src]="application.shortName | moduleDisplayLogo | async"
                    [id]="'imgURL' + application.shortName"
                  />
                </div>
                <div
                  *ngIf="application.shortName ==='T2S'; else elseBlock"
                  class="c-app-text"
                  [id]="'divTxt' + application.shortName"
                >
                  {{ "demo.d2s" | translate }}
                </div>
                <ng-template #elseBlock>
                  <div #elseBlock class="c-app-text" [id]="'divTxt' + application.shortName">
                    {{ application.shortName | moduleDisplayName | async }}
                  </div>
                </ng-template>
              </div>
            </a>
          </mat-grid-tile>
        </div>
      </ng-container>
    </mat-grid-list>
  </mat-menu>
</div>
